import React from "react";

import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { AudienceSegment } from "@/types";

interface NumberBoxProps {
  label: string;
  value: number;
  options: number[];
  onChange: (event: SelectChangeEvent<number>) => void;
  size?: "medium" | "small";
}

const NumberBox: React.FC<NumberBoxProps> = ({
  label,
  value,
  options,
  onChange,
  size = "small",
}) => {
  const theme = useTheme();

  return (
    <Select
      size={size}
      variant="outlined"
      value={value}
      onChange={onChange}
      displayEmpty
      sx={{
        minWidth: "60px",
        "& > fieldset": {
          borderColor: theme.palette.primary.main,
        },
      }}
    >
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
};

export default NumberBox;
